import { base64toHEX, padLeft, secondsToTimeString } from "./convert-utils";

import { ReportDto } from "src/services";
import { generatePdf } from "src/services/pdf.service";

const SystemID: string = "SystemID";
const EndTime: string = "EndTime";
const GroupPasses: string = "GroupPasses";
const SysInfoBiosDate: string = "SystemID";
const SysInfoBiosVersion: string = "SystemID";

function getDump(base64: string) {
  const hex = base64toHEX(base64);

  let curPos = 0;
  let offset = 0;
  const len = hex.length;

  const lines = [];
  while (curPos < len) {
    lines.push(`0x${padLeft(8, offset.toString(16))}: ${hex.slice(curPos, curPos + 2 * 16 + 16)}`);
    curPos += 2 * 16 + 16;

    offset += 16;
  }

  return lines;
}

export function transformReport(reportData: string) {
  const report = JSON.parse(reportData);

  const objectSizeGB = Math.round((100 * report.ObjectSize) / 1024 / 1024 / 1024) / 100;
  const objectSizeString = `${objectSizeGB} GB (${report.ObjectSize} bytes)`;

  const durationString = secondsToTimeString(report.Duration);

  const first = "0x" + padLeft(20, report.FirstSector.toString(16));
  const middle = "0x" + padLeft(20, report.MiddleSector.toString(16));
  const end = "0x" + padLeft(20, report.EndSector.toString(16));

  report.ObjectSize = objectSizeString;
  report.Duration = durationString;

  report.FirstSector = first;
  report.FirstSectorDump = getDump(report.FirstSectorDump);

  report.MiddleSector = middle;
  report.MiddleSectorDump = getDump(report.MiddleSectorDump);

  report.EndSector = end;
  report.EndSectorDump = getDump(report.EndSectorDump);

  report.SysInfoProductId = report.SysInfoProductId || "00000-00000-00000-00000";

  for (let i = 1; i <= 5; i++) {
    delete report[`Mask${i}`];
    delete report[`PassCount${i}`];
  }

  delete report[SystemID];
  delete report[EndTime];
  delete report[GroupPasses];
  delete report[SysInfoBiosDate];
  delete report[SysInfoBiosVersion];

  return report;
}

export function downloadFile(data: any, filename: string, mime: string) {
  const blob = new Blob([data], { type: mime || "application/octet-stream" });
  if (typeof window.navigator.msSaveBlob !== "undefined") {
    // IE workaround for "HTML7007: One or more blob URLs were
    // revoked by closing the blob for which they were created.
    // These URLs will no longer resolve as the data backing
    // the URL has been freed."
    window.navigator.msSaveBlob(blob, filename);
  } else {
    const blobURL = window.URL.createObjectURL(blob);
    const tempLink = document.createElement("a");
    tempLink.style.display = "none";
    tempLink.href = blobURL;
    tempLink.setAttribute("download", filename);

    // Safari thinks _blank anchor are pop ups. We only want to set _blank
    // target if the browser does not support the HTML5 download attribute.
    // This allows you to download files in desktop safari if pop up blocking
    // is enabled.
    if (typeof tempLink.download === "undefined") {
      tempLink.setAttribute("target", "_blank");
    }

    document.body.appendChild(tempLink);
    tempLink.click();
    document.body.removeChild(tempLink);
    window.URL.revokeObjectURL(blobURL);
  }
}

export function printReport(report: ReportDto, browserWindow?: Window | null): void {
  const adaptedForPdf = transformReport(report.reportData);

  generatePdf(adaptedForPdf)
    .then(response => response.blob())
    .then(blob => {
      const pdfBlob = new Blob([blob], { type: "application/pdf" });

      const fileURL = window.URL.createObjectURL(pdfBlob);
      // to avoid pop-up blocking, we open a new window
      // on user's action in order to put content there later
      const newWindow = browserWindow ? browserWindow : window.open("", "_blank");
      if (!newWindow) {
        return;
      }

      newWindow.document.write("Loading preview...");

      newWindow.location.href = fileURL;
    })
    .catch(err => {
      alert("The report is in an incorrect format");
    });
}

export function downloadReport(id: string, report: ReportDto): void {
  try {
    const adaptedForPdf = transformReport(report.reportData);

    generatePdf(adaptedForPdf)
      .then(response => response.blob())
      .then(blob => {
        downloadFile(blob, `report-${id}.pdf`, "application/pdf");
      })
      .catch(err => {
        alert("The report is in an incorrect format");
      });
  } catch (err) {
    // TODO: show alert at the top of the windows.
    alert("The report is in an incorrect format");
  }
}



// WEBPACK FOOTER //
// ./src/helpers/report-utils.ts